import { INavigationState } from "@/services/store/modules/navigation/navigation-types";

export const state: INavigationState = {
  error: null,
  loading: false,
  menuItems: [],
};
